import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Customer, CustomerOrder } from '@app/utils/interfaces/customer.interface';
import { CustomerService } from '../../services/customers.service';

@Component({
  selector: 'app-customer-order-history-section',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './customer-order-history-section.component.html',
  styleUrl: './customer-order-history-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerOrderHistorySectionComponent implements OnInit {
  public readonly customerInfo = input<Customer | null>();
  public readonly closeDialog = output<void>();

  public readonly isActive = computed(() => this.customerInfo()?.isActive);
  private readonly customerService = inject(CustomerService);

  public readonly orders = signal<CustomerOrder[]>([]);
  public readonly isLoading = signal(false);
  public readonly pageSize = signal(10);
  public readonly pageNumber = signal(1);
  public readonly totalAmount = signal(0);

  public ngOnInit(): void {
    this.loadOrders();
  }

  public onClose(): void {
    this.closeDialog.emit();
  }

  public loadOrders(): void {
    const customerId = this.customerInfo()?.accountId;

    if (!customerId) {
      this.orders.set([]);
      this.totalAmount.set(0);
      return;
    }

    this.isLoading.set(true);

    this.customerService
      .getCustomerOrders(customerId, {
        pageNumber: this.pageNumber(),
        pageSize: this.pageSize(),
      })
      .subscribe({
        next: (response) => {
          this.orders.set(response.data.items);
          this.totalAmount.set(response.data.totalAmount);
          this.isLoading.set(false);
        },
        error: () => {
          this.orders.set([]);
          this.totalAmount.set(0);
          this.isLoading.set(false);
        },
      });
  }

  public getStatusClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'done':
        return 'status status--done';
      case 'in progress':
        return 'status status--in-progress';
      case 'cancelled':
        return 'status status--cancelled';
      default:
        return 'status';
    }
  }
}
